module.exports = __webpack_public_path__ + "img/yml_gallery8.d7a5a992.jpg";